/* ============================================================
   Backport: details-based desktop mega menu (Impulse 2025 hover menu)
   Standalone — no jQuery/theme.js dependency. Function bodies ported
   from SOURCE theme.headerNav.menuDetailsHandler() and
   theme.HeaderSection.hoverMenu(); selector adapted to TARGET's
   [data-section-type="header-section"] container. Guards added
   because this runs outside the theme.sections lifecycle.
   ============================================================ */
(function() {
  var escapeHandlerBound = false;

  function initHoverMenu() {
    // From SOURCE theme.headerNav.menuDetailsHandler()
    var navDetails = document.querySelectorAll('.site-nav__details');

    navDetails.forEach(function(navDetail) {
      if (navDetail.dataset.detailsInit === 'true') return;
      navDetail.dataset.detailsInit = 'true';

      var summary = navDetail.querySelector('summary');

      // if the navDetail is open, then close it when the user clicks outside of it
      document.addEventListener('click', function(evt) {
        if (navDetail.hasAttribute('open') && !navDetail.contains(evt.target)) {
          navDetail.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        } else {
          if (navDetail.hasAttribute('open')) {
            summary.setAttribute('aria-expanded', 'false');
          } else {
            summary.setAttribute('aria-expanded', 'true');
          }
        }
      });
    });

    // From SOURCE theme.HeaderSection.hoverMenu()
    // (selector adapted: TARGET uses data-section-type="header-section")
    var detailsEl = document.querySelectorAll('[data-section-type="header-section"] details[data-hover="true"]');

    detailsEl.forEach(function(detail) {
      if (detail.dataset.hoverInit === 'true') return;
      detail.dataset.hoverInit = 'true';
      var summary = detail.querySelector('summary');
      var summaryLink = summary.dataset.link;

      summary.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = summaryLink;
      });

      // if detail has :focus-within
      detail.addEventListener('focusin', function() {
        if (!detail.hasAttribute('open')) {

          // close all other details
          detailsEl.forEach(function(otherDetail) {
            otherDetail.removeAttribute('open');
            otherDetail.setAttribute('aria-expanded', 'false');
          });

          detail.setAttribute('open', '');
          detail.setAttribute('aria-expanded', 'true');
        }
      });

      detail.addEventListener('focusout', function() {
        if (detail.hasAttribute('open') && !detail.matches(':focus-within')) {
          detail.removeAttribute('open');
          detail.setAttribute('aria-expanded', 'false');
        }
      });

      detail.addEventListener('mouseover', function() {
        if (!detail.hasAttribute('open')) {
          detail.setAttribute('open', '');
          detail.setAttribute('aria-expanded', 'true');
        }
      });

      detail.addEventListener('mouseleave', function() {
        if (detail.hasAttribute('open')) {
          detail.removeAttribute('open');
          detail.setAttribute('aria-expanded', 'false');
        }
      });
    });
    // Escape closes any open nav dropdown
    if (!escapeHandlerBound) {
      escapeHandlerBound = true;
      document.addEventListener('keydown', function(evt) {
        if (evt.key !== 'Escape' && evt.keyCode !== 27) return;
        document.querySelectorAll('.site-nav__details[open]').forEach(function(openDetail) {
          openDetail.removeAttribute('open');
          openDetail.setAttribute('aria-expanded', 'false');
          var openSummary = openDetail.querySelector('summary');
          if (openSummary) {
            openSummary.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenu);
  } else {
    initHoverMenu();
  }
  // Theme editor: header section DOM is replaced on reload
  document.addEventListener('shopify:section:load', initHoverMenu);
})();